import React from 'react';
import i18n from "../../../i18n";
import {Form, Button} from "../../../components";


const Youtube = props => {
    const handleChange = formValues => props.onChange({uuid: props.uuid, type: "youtube", url: formValues.url});
    return (
        <div>
            <h6>Youtube</h6>
            <Form formData={{url: {label: "URL"}}} values={{url: props.url}} onChange={handleChange} stacked/>
            <Button round color="danger" onClick={props.onRemove}>{i18n.photoDelete}</Button>
        </div>
    );
};

export default Youtube;